module.exports = __webpack_public_path__ + "static/BG_Fitur_Unik-f9abf28c4931bf3979652bbf6c7ac509.jpg";